// The phone's "More": a small bottom sheet, not a side menu. Home is the app on a phone (a few big tiles); anything else is a short list here, one tap each, plus Sign Out. Tap outside to close.
import React from 'react';
import Button from './Button';

export const PHONE_MORE = [
  ['lead-management', 'Scheduled Sends', { tab: 'scheduled' }],
  ['lead-management', 'Network', { tab: 'network' }],
  ['lead-management', 'Moved On', { tab: 'movedon' }],
  ['lead-management', 'Maybe Not Leads: Check These', { tab: 'notleads' }],
  ['focus-board', 'Focus'],
  ['dashboard', 'Dashboard'],
  ['settings', 'Settings'],
  ['mobile-capture', 'Mobile capture'],
];

const row = { display: 'flex', alignItems: 'center', width: '100%', minHeight: 48, padding: '0 16px', background: 'none', border: 'none', borderTop: '1px solid var(--gov-line, #e2e8f0)', fontSize: 16, fontWeight: 600, color: 'var(--gov-ink, #1a2133)', cursor: 'pointer', textAlign: 'left', boxSizing: 'border-box' };

export default function PhoneMoreSheet({ open, onClose, onNavigate, onSignOut }) {
  if (!open) return null;
  return (
    <div data-testid="phone-more" onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.45)', zIndex: 495, display: 'flex', alignItems: 'flex-end' }}>
      <div role="dialog" aria-modal="true" aria-label="More" onClick={(e) => e.stopPropagation()}
        style={{ background: '#fff', width: '100%', borderRadius: '16px 16px 0 0', maxHeight: '75vh', overflowY: 'auto', paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}>
        <div style={{ padding: '14px 16px 8px', fontSize: 13, fontWeight: 700, color: 'var(--gov-text-sub, #64748b)', textTransform: 'uppercase', letterSpacing: '0.06em' }}>More</div>
        {PHONE_MORE.map(([key, label, params]) => (
          <Button key={label} type="button" onClick={() => { onClose(); onNavigate(key, params); }} style={row}>{label}</Button>
        ))}
        <Button type="button" onClick={() => { onClose(); onSignOut(); }} style={{ ...row, color: 'var(--gov-text-sub, #64748b)' }}>Sign Out</Button>
      </div>
    </div>
  );
}


